import {
    GET_DASHBOARD_DATA, GET_COUNT_DETAIL, GET_LIST_DETAIL, GET_IMD_CODES, SET_EMPTY_IMD,
    GET_RELATION_CODES, SET_EMPTY_RELATION_CODES, GET_FE_LIST, SET_SELECTED_TAB, SET_SELECTED_MENU, SET_FORM_VALUE, CLEAR_FORM_VALUE,
    AT_WORK,NOT_LOGGED_IN,GET_CAPACITY_UTILIZATION,REMOVE_CAPACITY_UTILIZATION,REMOVE_COUNT_DETAIL
} from '../types/HomeType'

const initState = {
    dashboardData: {}, countDetail: {}, listDetail: [], imdCodes: [], relationCodes: [], fEList: [],
    selectedTab: "portfolio", selectedMenu: 'lob_bifurcation', formValue: {}, atWork:{},notLoggedIn:{},capacityUtilizations:[]
}

export const HomeReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_DASHBOARD_DATA:
            return {
                ...state,
                dashboardData: !action.error ? action.payload : state.dashboardData
            }
        case GET_COUNT_DETAIL:
            return {
                ...state,
                countDetail: !action.error ? action.payload : {}
            }
            case REMOVE_COUNT_DETAIL:
                return {
                    ...state,
                    countDetail: {}
                }            
        case GET_CAPACITY_UTILIZATION:
                return {
                    ...state,
                    capacityUtilizations: !action.error ? action.payload : []
                }  
        case REMOVE_CAPACITY_UTILIZATION:
            return {
                ...state,
                capacityUtilizations:[]
            }          
        case GET_LIST_DETAIL:
            return {
                ...state,
                listDetail: !action.error ? action.payload.list : []
            }
        case GET_IMD_CODES:
            return {
                ...state,
                imdCodes: !action.error ? action.payload.filter(obj => obj.intermediaryCode !== null) : []
            }
        case GET_RELATION_CODES:
            return {
                ...state,
                relationCodes: !action.error ? action.payload : []
            }
        case SET_EMPTY_IMD:
            return {
                ...state,
                imdCodes: []
            }
        case SET_EMPTY_RELATION_CODES:
            return {
                ...state,
                relationCodes: []
            }
        case GET_FE_LIST:
            return {
                ...state,
                fEList: !action.error ? action.payload : []
            }
        case SET_SELECTED_TAB:
            return {
                ...state,
                selectedTab: action.payload.tabName,
                selectedMenu: action.payload.menu
            }
        case SET_SELECTED_MENU:
            return {
                ...state,
                selectedMenu: action.payload
            }
        case SET_FORM_VALUE:
            return {
                ...state,
                formValue: action.payload
            }
        case CLEAR_FORM_VALUE:
            return {
                ...state,
                formValue: {}
            }
        case AT_WORK:
            return {
                ...state,
                atWork:action.payload
            }
        case NOT_LOGGED_IN:
            return {
                ...state,
                notLoggedIn:action.payload
            }    
        default:
            return state;
    }
}